var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { orderWiseProductsData, duplicateOrderData } from "../../../reduxStore/actions/salesRepDataAction";
import store from "../../../reduxStore/store";
import { isLoading, salesOrderSearchText } from "../../../services/behaviorSubjectService";
import { useEffect, useState, useMemo } from "react";
import { EDIT_ORDER_FLAG } from "../../Constant";
import { SalesRepDataActionType } from "../../../reduxStore/actions/actionTypes";
import { handleMenuClick as sharedHandleMenuClick, handleMenuClose, handleDuplicateOrderFromDialog, mergeCustomerDataToRedux, } from "../SalesOrderDetailsSharedBL";
import { formatIssueDateFromObject, formatDueDateFromObject, getPaymentTermsDescription, getDisplayPaymentTermsData } from "../../SharedFunctions";
import { resolvePaymentTermsForDisplay } from "../../PaymentTerms/DraftOrderPaymentTerms";
export function PendingOrdersBL(columnVisibility) {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var cv = columnVisibility;
    var shopCurrency = store.getState().salesRepData.loggedInRepDetails.shopCurrency;
    var currency = store.getState().salesRepData.loggedInRepDetails.currency;
    var salesRepData = useSelector(function (state) { return (state.salesRepData ? state.salesRepData : {}); });
    var _j = useState(((_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.ordersData) === null || _a === void 0 ? void 0 : _a.AllOrdersCommission) ? (_b = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.ordersData) === null || _b === void 0 ? void 0 : _b.AllOrdersCommission : []), pendingOrders = _j[0], setPendingOrders = _j[1];
    var _k = useState(((_d = (_c = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.ordersData) === null || _c === void 0 ? void 0 : _c.AllOrdersCommission) === null || _d === void 0 ? void 0 : _d.length) > 0 ? false : true), orderesLoading = _k[0], setOrdersLoading = _k[1];
    var selectFeatures = (_e = store.getState().salesRepData.baseData.select) !== null && _e !== void 0 ? _e : {};
    var PendingOrdersHeaderNames = [
        {
            label: t("draftOrder_OrderNumber"),
            hidden: (cv === null || cv === void 0 ? void 0 : cv.orderNumber) === false,
        },
        {
            label: t("draftOrder_CustName"),
            hidden: (cv === null || cv === void 0 ? void 0 : cv.customerName) === false,
        },
        {
            label: t("salesDetailsHeader_Company"),
            hidden: !(selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateB2BOrder) || (cv === null || cv === void 0 ? void 0 : cv.companyName) === false,
        },
        {
            label: t("salesDetailsHeader_Location"),
            hidden: !(selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateB2BOrder) || (cv === null || cv === void 0 ? void 0 : cv.companyLocation) === false,
        },
        {
            label: t("draftOrder_OrderDate"),
            hidden: (cv === null || cv === void 0 ? void 0 : cv.orderDate) === false,
        },
        {
            label: t("draftOrder_SubTotal") + "(" + shopCurrency + ")",
            hidden: (cv === null || cv === void 0 ? void 0 : cv.subtotal) === false,
        },
        {
            label: t("draftOrder_Status"),
            hidden: (cv === null || cv === void 0 ? void 0 : cv.status) === false,
        },
        {
            label: t("yourSales_Action"),
            inlineCSS: { textAlign: "center" },
            hidden: false,
        },
    ];
    var ProductSalesDetailsHeaderNames = [
        {
            label: t("yourSales_column1"),
        },
        {
            label: t("yourSales_column2"),
        },
        {
            label: t("variant_title"),
        },
        {
            label: "SKU",
        },
        {
            label: t("yourSales_column3"),
        },
        {
            label: t("yourSales_column4") + "(" + shopCurrency + ")",
        },
        {
            label: t("viewProductModelColumn6") + "(" + shopCurrency + ")",
        },
        {
            label: t("yourSales_column5"),
        },
        {
            label: t("yourSales_column6"),
        },
        {
            label: t("yourSales_column7") + "(" + shopCurrency + ")",
        },
    ];
    var _l = useState(((_f = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.ordersData) === null || _f === void 0 ? void 0 : _f.AllOrdersCommission) ? (_g = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.ordersData) === null || _g === void 0 ? void 0 : _g.AllOrdersCommission : []), filtered = _l[0], setFiltered = _l[1];
    var _m = useState(""), searchPendingOrderText = _m[0], setSearchPendingOrderText = _m[1];
    useEffect(function () {
        var _a, _b;
        if ((pendingOrders === null || pendingOrders === void 0 ? void 0 : pendingOrders.length) === 0 && ((_b = (_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.ordersData) === null || _a === void 0 ? void 0 : _a.AllOrdersCommission) === null || _b === void 0 ? void 0 : _b.length) === 0) {
            setOrdersLoading(false);
        }
    }, []);
    useEffect(function () {
        var _a, _b, _c, _d;
        if ((pendingOrders === null || pendingOrders === void 0 ? void 0 : pendingOrders.length) === 0 && ((_b = (_a = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.ordersData) === null || _a === void 0 ? void 0 : _a.AllOrdersCommission) === null || _b === void 0 ? void 0 : _b.length) > 0) {
            setPendingOrders((_c = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.ordersData) === null || _c === void 0 ? void 0 : _c.AllOrdersCommission);
            setFiltered((_d = salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.ordersData) === null || _d === void 0 ? void 0 : _d.AllOrdersCommission);
            setOrdersLoading(false);
        }
    }, [salesRepData === null || salesRepData === void 0 ? void 0 : salesRepData.ordersData]);
    useEffect(function () {
        var filterTable = salesOrderSearchText === null || salesOrderSearchText === void 0 ? void 0 : salesOrderSearchText.subscribe(function (data) {
            if ((data === null || data === void 0 ? void 0 : data.orderTab) === "Unpaid" && (data === null || data === void 0 ? void 0 : data.searchText) !== searchPendingOrderText) {
                setSearchPendingOrderText(data === null || data === void 0 ? void 0 : data.searchText);
                var updatedArray = __spreadArray([], filtered, true);
                var filteredOrders = updatedArray === null || updatedArray === void 0 ? void 0 : updatedArray.filter(function (order) { var _a, _b, _c, _d, _e, _f; return ((_b = (_a = order === null || order === void 0 ? void 0 : order.CustomerName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes((_c = data === null || data === void 0 ? void 0 : data.searchText) === null || _c === void 0 ? void 0 : _c.toLowerCase())) || ((_e = (_d = order === null || order === void 0 ? void 0 : order.orderNumber) === null || _d === void 0 ? void 0 : _d.toLowerCase()) === null || _e === void 0 ? void 0 : _e.includes((_f = data === null || data === void 0 ? void 0 : data.searchText) === null || _f === void 0 ? void 0 : _f.toLowerCase())); });
                setPendingOrders(filteredOrders);
            }
        });
        return function () { return filterTable.unsubscribe(); };
    }, [pendingOrders, searchPendingOrderText, setPendingOrders]);
    var pendingOrdersArray = (_h = pendingOrders === null || pendingOrders === void 0 ? void 0 : pendingOrders.filter(function (data) {
        var _a;
        return ((_a = data === null || data === void 0 ? void 0 : data.OrderStatus) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "pending";
    })) !== null && _h !== void 0 ? _h : [];
    var _o = useState(false), openProductDataDialog = _o[0], setOpenProductDataDialog = _o[1];
    var _p = useState(null), pendingDialogSourceRow = _p[0], setPendingDialogSourceRow = _p[1];
    var _q = useState(), activeClientObj = _q[0], setActiveClientObj = _q[1];
    var _r = useState([]), pendingProductArray = _r[0], setPendingSalesProductArray = _r[1];
    var _s = useState(null), menuAnchorEl = _s[0], setMenuAnchorEl = _s[1];
    var _t = useState(null), selectedOrder = _t[0], setSelectedOrder = _t[1];
    var _u = useState({ msg: "", open: false, severity: "error" }), alertErrorMsg = _u[0], setAlertErrorMsg = _u[1];
    var displayPaymentTerms = useMemo(function () {
        return resolvePaymentTermsForDisplay(activeClientObj);
    }, [activeClientObj]);
    var displayPaymentTermsData = useMemo(function () { return getDisplayPaymentTermsData(displayPaymentTerms, activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.paymentTerms); }, [displayPaymentTerms, activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.paymentTerms]);
    var getPendingProductsData = function (product) { return __awaiter(_this, void 0, void 0, function () {
        var params, saleWiseProducts;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setPendingDialogSourceRow(product);
                    params = {
                        order_id: product.OrderId,
                    };
                    isLoading.next(true);
                    return [4 /*yield*/, dispatch(orderWiseProductsData(params))];
                case 1:
                    saleWiseProducts = _a.sent();
                    setOpenProductDataDialog(true);
                    saleWiseProducts ? setPendingSalesProductArray(saleWiseProducts.ProductDetails) : setPendingSalesProductArray([]);
                    setActiveClientObj(saleWiseProducts.singleOrderDetailsFromShopify);
                    isLoading.next(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var closeProductDataDialog = function () {
        setOpenProductDataDialog(false);
        setPendingDialogSourceRow(null);
    };
    var handleMenuClick = function (event, order) {
        sharedHandleMenuClick(event, order, menuAnchorEl, selectedOrder, setMenuAnchorEl, setSelectedOrder);
    };
    var handleDuplicateOrder = function () { return __awaiter(_this, void 0, void 0, function () {
        var orderToProcess, latestOrderFromStore, orderToUse, orderIdFromRow, status_1, isDraftOrder, orderIdForDuplicate, orderDetailsForMerge, saleWiseProducts, params, response, error_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    orderToProcess = selectedOrder;
                    handleMenuClose(setMenuAnchorEl, setSelectedOrder);
                    if (!orderToProcess)
                        return [2 /*return*/];
                    isLoading.next(true);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 7, 8, 9]);
                    latestOrderFromStore = pendingOrders.find(function (order) { return order.OrderId === orderToProcess.OrderId; });
                    orderToUse = latestOrderFromStore || orderToProcess;
                    orderIdFromRow = (_a = orderToUse === null || orderToUse === void 0 ? void 0 : orderToUse.OrderId) !== null && _a !== void 0 ? _a : orderToProcess.OrderId;
                    status_1 = (orderToUse === null || orderToUse === void 0 ? void 0 : orderToUse.OrderStatus) ? orderToUse.OrderStatus.toLowerCase() : "";
                    isDraftOrder = ["open"].includes(status_1);
                    orderIdForDuplicate = orderIdFromRow;
                    orderDetailsForMerge = null;
                    if (!!isDraftOrder) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(orderWiseProductsData({ order_id: orderIdFromRow }))];
                case 2:
                    saleWiseProducts = _d.sent();
                    orderDetailsForMerge = saleWiseProducts === null || saleWiseProducts === void 0 ? void 0 : saleWiseProducts.singleOrderDetailsFromShopify;
                    orderIdForDuplicate = (_c = (_b = orderDetailsForMerge === null || orderDetailsForMerge === void 0 ? void 0 : orderDetailsForMerge.id) !== null && _b !== void 0 ? _b : orderDetailsForMerge === null || orderDetailsForMerge === void 0 ? void 0 : orderDetailsForMerge.order_id) !== null && _c !== void 0 ? _c : orderIdFromRow;
                    _d.label = 3;
                case 3:
                    params = { order_id: orderIdForDuplicate, isDraftOrder: isDraftOrder };
                    return [4 /*yield*/, dispatch(duplicateOrderData(params, EDIT_ORDER_FLAG))];
                case 4:
                    response = _d.sent();
                    if (!(response === null || response === void 0 ? void 0 : response.draftOrder) || Object.keys(response.draftOrder).length === 0) {
                        setAlertErrorMsg({ msg: t("draftOrder_DuplicateErrorMsg_TryAgain"), open: true, severity: "error" });
                        isLoading.next(false);
                        return [2 /*return*/];
                    }
                    if (!orderDetailsForMerge) return [3 /*break*/, 6];
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 100); })];
                case 5:
                    _d.sent();
                    mergeCustomerDataToRedux(orderDetailsForMerge, dispatch);
                    _d.label = 6;
                case 6:
                    dispatch({
                        type: SalesRepDataActionType.ACTIVE_TAB,
                        payload: { activeTabIndex: 1, actionEvent: EDIT_ORDER_FLAG },
                    });
                    return [3 /*break*/, 9];
                case 7:
                    error_1 = _d.sent();
                    setAlertErrorMsg({ msg: t("draftOrder_DuplicateErrorMsg_General"), open: true, severity: "error" });
                    return [3 /*break*/, 9];
                case 8:
                    isLoading.next(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var handleAlertMsgClose = function (event, reason) {
        if (reason === "clickaway") {
            return;
        }
        setAlertErrorMsg({ msg: "", open: false });
    };
    var handleDuplicateUnpaidOrder = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setOpenProductDataDialog(false);
                    setPendingDialogSourceRow(null);
                    return [4 /*yield*/, handleDuplicateOrderFromDialog(activeClientObj, (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.id) || (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.order_id), false, dispatch, setAlertErrorMsg, t)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    return {
        PendingOrdersHeaderNames: PendingOrdersHeaderNames,
        pendingOrdersArray: pendingOrdersArray,
        t: t,
        getPendingProductsData: getPendingProductsData,
        openProductDataDialog: openProductDataDialog,
        activeClientObj: activeClientObj,
        pendingProductArray: pendingProductArray,
        setOpenProductDataDialog: setOpenProductDataDialog,
        closeProductDataDialog: closeProductDataDialog,
        pendingDialogSourceRow: pendingDialogSourceRow,
        ProductSalesDetailsHeaderNames: ProductSalesDetailsHeaderNames,
        orderesLoading: orderesLoading,
        selectFeatures: selectFeatures,
        currency: currency,
        shopCurrency: shopCurrency,
        menuAnchorEl: menuAnchorEl,
        selectedOrder: selectedOrder,
        handleMenuClick: handleMenuClick,
        handleMenuClose: function () { return handleMenuClose(setMenuAnchorEl, setSelectedOrder); },
        handleDuplicateOrder: handleDuplicateOrder,
        handleDuplicateUnpaidOrder: handleDuplicateUnpaidOrder,
        alertErrorMsg: alertErrorMsg,
        handleAlertMsgClose: handleAlertMsgClose,
        displayPaymentTerms: displayPaymentTerms,
        displayPaymentTermsData: displayPaymentTermsData,
        getPaymentTermsDescription: getPaymentTermsDescription,
        getIssueDate: function () { return formatIssueDateFromObject(displayPaymentTermsData); },
        getDueDate: function () { return formatDueDateFromObject(displayPaymentTermsData); },
    };
}
